/* eslint-disable import/prefer-default-export */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/prop-types */
/* eslint-disable no-trailing-spaces */
/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import { Url } from "./http";
import httpServices from "./httpServices";

//const apiUrl = "https://localhost:7148/api";

const apiUrl = Url.baseUrl;

export class DataHelper {
    getList = (controllerName, pageSize, pageNumber, orderBy, orderDirection, criteria) => {
        let url = `${apiUrl}/${controllerName}/GetList?pageSize=${pageSize}&pageNumber=${pageNumber}`;
        if (orderBy) url += `&orderBy=${orderBy}`;
        if (orderDirection) url += `&orderDirection=${orderDirection}`;
        if (criteria) url += `&criteria=${encodeURIComponent(JSON.stringify(criteria))}`;
        return httpServices.get(url);
    }

    save = (controllerName, dataObject) => {
        return httpServices.post(`${apiUrl}/${controllerName}/Save`, { dataObj: JSON.stringify(dataObject) });
    }

    SaveLoyaltyPoint = (controllerName, dataObject) => {
        return httpServices.post(`${apiUrl}/${controllerName}/SaveLoyaltyPoint`, { dataObj: JSON.stringify(dataObject) });
    }


    delete = (controllerName, dataObject) => {
        return httpServices.post(`${apiUrl}/${controllerName}/Delete`, { dataObj: JSON.stringify(dataObject) },);
    }

    getNextCode = (controllerName) => {
        return httpServices.get(`${apiUrl}/${controllerName}/GetNextCode`,);
    }

    checkCodeExist = (code) => {
        return httpServices.get(`${apiUrl}/${this.controller}/CheckCodeExist?code=${code}`);
    }

    getById(controllerName, id) {
        return httpServices.get(`${apiUrl}/${controllerName}/GetByID?ID=${id}`,);
    }

}
